// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { IntegratorDTO } from './integrator-dto';
import { OrderManualPaymentDTO } from './order-manual-payment-dto';
import { PolicyDTO } from './policy-dto';

/**
 * 
 * @export
 * @interface OrderDTO
 */
export interface OrderDTO {
    /**
     * 
     * @type {string}
     * @memberof OrderDTO
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDTO
     */
    productId: OrderDTOProductIdEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderDTO
     */
    statusId: OrderDTOStatusIdEnum;
    /**
     * 
     * @type {object}
     * @memberof OrderDTO
     */
    details: object;
    /**
     * 
     * @type {number}
     * @memberof OrderDTO
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof OrderDTO
     */
    policyId?: string;
    /**
     * 
     * @type {PolicyDTO}
     * @memberof OrderDTO
     */
    policy?: PolicyDTO;
    /**
     * 
     * @type {Array<PolicyDTO>}
     * @memberof OrderDTO
     */
    policies?: Array<PolicyDTO>;
    /**
     * 
     * @type {string}
     * @memberof OrderDTO
     */
    redirectUrl: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDTO
     */
    completedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDTO
     */
    integratorId?: string;
    /**
     * 
     * @type {IntegratorDTO}
     * @memberof OrderDTO
     */
    integrator?: IntegratorDTO;
    /**
     * 
     * @type {Array<OrderManualPaymentDTO>}
     * @memberof OrderDTO
     */
    manualPayments?: Array<OrderManualPaymentDTO>;
    /**
     * 
     * @type {string}
     * @memberof OrderDTO
     */
    refundHandling?: OrderDTORefundHandlingEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderDTO
     */
    disputeHandling?: OrderDTODisputeHandlingEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum OrderDTOProductIdEnum {
    REPOSIT = 'REPOSIT',
    CLAIM = 'CLAIM',
    CLAIMPROPOSAL = 'CLAIM_PROPOSAL',
    ARBITRATION = 'ARBITRATION',
    TOPUP = 'TOP_UP',
    ARBITRATIONADMINFEE = 'ARBITRATION_ADMIN_FEE'
}
/**
    * @export
    * @enum {string}
    */
export enum OrderDTOStatusIdEnum {
    DRAFT = 'DRAFT',
    PENDING = 'PENDING',
    COMPLETE = 'COMPLETE',
    CANCELLED = 'CANCELLED',
    REFUNDED = 'REFUNDED'
}
/**
    * @export
    * @enum {string}
    */
export enum OrderDTORefundHandlingEnum {
    MANUAL = 'MANUAL',
    AUTOMATIC = 'AUTOMATIC'
}
/**
    * @export
    * @enum {string}
    */
export enum OrderDTODisputeHandlingEnum {
    MANUAL = 'MANUAL',
    AUTOMATIC = 'AUTOMATIC'
}



